import { Outlet } from 'react-router-dom';

const MockContainer = () => <Outlet />;

export default MockContainer;